import PenlyPlayPension from './PenlyPlayPension';

export default PenlyPlayPension;
